import React from "react";

function TickIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="19"
      viewBox="0 0 25 19"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero">
          <path d="M23.204.2L7.388 16.074l-5.592-5.613a.676.676 0 00-.958 0l-.64.642a.682.682 0 000 .962l6.71 6.735a.676.676 0 00.959 0L24.801 1.803a.682.682 0 000-.962l-.639-.642a.676.676 0 00-.958 0z"></path>
        </g>
      </g>
    </svg>
  );
}

export default TickIcon;
